import {
  createAuthStorage,
  type IBaseAuthStorage,
} from './createAuthStorage.ts';

interface IAuthStorage extends IBaseAuthStorage {}

export const AuthStorage = createAuthStorage<IAuthStorage>({
  storage:
    typeof window == 'undefined' ? ({} as Storage) : window?.localStorage,
  initialValues: {
    isLogged: false,
    isPrelogged: false,
    strategy: null,
    refreshToken: null,
    logoutUrls: null,
  },
});
